import { IActivityDetail } from './iactivity-detail';

export interface IDecubitusPositionCodeableConcept {
    coding: string;
    text: string;
    // activityDetail: IActivityDetail[];
}
